<template>
    <div class="ix-formbuilder-component-summary-content">
        <div class="formbuilder-component boxed" v-if="displayMode == 'readable' || displayMode == 'fillable'">
            <div style="display:flex" class="formbuilder-component-content">
                <div class="formbuilder-component-left">
                    <label class="formbuilder-component-label" v-bind:class="{'required' : currentField.required}">{{ currentField.label }}</label>
                    <p class="formbuilder-component-help" v-if="currentField.helper">{{ currentField.helper }}</p>
                </div>

                <div class="formbuilder-component-right" v-if="displayMode == 'readable'">
                    <span class="formbuilder-indications">Un seul choix possible</span>
                    <div class="formbuilder-option" v-for="(option,index) in currentField.options" :key="index">
                            <span class="formbuilder-checkbox round">
                                <span v-if="currentField.value == option.value" class="tick">&#10004;</span>
                        </span> 
                        {{ option.value }}
                    </div>
                </div>

                <div class="formbuilder-component-right" v-if="displayMode == 'fillable'" style="width: 100% !important">
                    <div class="form-check" v-for="(item,i) in currentField.options" :key="i">
                        <input class="form-check-input" type="radio" :id="'radio-'+index+'-'+i" v-model="currentField.value" :value="item.value">
                        <label class="form-check-label" :for="'radio-'+index+'-'+i">{{ item.value }}</label>
                    </div>
                </div>

                <div class="clearfix"></div>
            </div>
        </div>

        <div v-if="displayMode == 'summary'" class="ix-formbuilder-component-summary-info">
            <div class="ix-formbuilder-component-summary-handle">
                <span class="ix-drag-icon handle-line"></span>
            </div>
            <div class="ix-formbuilder-component-summary-icon" data-toggle="tooltip" data-placement="top" title="Choix unique">
                <div class="ix-formbuilder-icon">
                    <i class="far fa-check-circle"></i>
                </div>
            </div>
            <div class="ix-formbuilder-component-summary-content">
                <span class="ix-formbuilder-component-summary-label" v-bind:class="{'required': currentField.required}">{{ currentField.label }}</span>
                <span class="ix-formbuilder-component-summary-help" v-if="currentField.helper">{{ currentField.helper }}</span>
                <ul class="ix-formbuilder-component-summary-options">
                    <li>{{ currentField.options.length }} option{{ currentField.options.length > 1 ? 's' : '' }}</li>
                </ul>
            </div>
        </div>

    </div>
</template>

<script>
    export default {
        name: "RadioComponent",
        props: ['currentField' , 'showIcon', 'displayMode' , 'index'],
        data() {
            return {
                radio: '1'
            }
        },
        mounted() {
            if(this.displayMode == "readable"){
                this.currentField.value = this.currentField.value ? this.currentField.value : 'Non renseigné'
            }
        }
    }
</script>
